var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 3.375H4.5C2.5875 3.375 1.125 4.8375 1.125 6.75V20.25C1.125 22.1625 2.5875 23.625 4.5 23.625H22.5C24.4125 23.625 25.875 22.1625 25.875 20.25V6.75C25.875 4.8375 24.4125 3.375 22.5 3.375ZM4.49993 5.625H22.4999C22.9499 5.625 23.2874 5.85 23.5124 6.3L13.4999 13.275L3.48743 6.3C3.71243 5.85 4.04993 5.625 4.49993 5.625ZM3.375 20.2501C3.375 20.9251 3.825 21.3751 4.5 21.3751H22.5C23.175 21.3751 23.625 20.9251 23.625 20.2501V8.88757L14.175 15.5251C13.95 15.6376 13.725 15.7501 13.5 15.7501C13.275 15.7501 13.05 15.6376 12.825 15.5251L3.375 8.88757V20.2501Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mail",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 25,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 3.375H4.5C2.5875 3.375 1.125 4.8375 1.125 6.75V20.25C1.125 22.1625 2.5875 23.625 4.5 23.625H22.5C24.4125 23.625 25.875 22.1625 25.875 20.25V6.75C25.875 4.8375 24.4125 3.375 22.5 3.375ZM4.49993 5.625H22.4999C22.9499 5.625 23.2874 5.85 23.5124 6.3L13.4999 13.275L3.48743 6.3C3.71243 5.85 4.04993 5.625 4.49993 5.625ZM3.375 20.2501C3.375 20.9251 3.825 21.3751 4.5 21.3751H22.5C23.175 21.3751 23.625 20.9251 23.625 20.2501V8.88757L14.175 15.5251C13.95 15.6376 13.725 15.7501 13.5 15.7501C13.275 15.7501 13.05 15.6376 12.825 15.5251L3.375 8.88757V20.2501Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mail)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d1a8b5b1537992775e5e7eb02402c135.svg";
export { ForwardRef as ReactComponent };